// Session + insight persistence via localStorage (survives PWA installs).
const KEY = "stillroom.sessions.v1";

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeAll(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch {
    /* ignore quota */
  }
}

export function listSessions() {
  return readAll().sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
}

export function getSession(id) {
  return readAll().find((s) => s.id === id) || null;
}

export function saveSession(session) {
  const all = readAll();
  const idx = all.findIndex((s) => s.id === session.id);
  if (idx >= 0) all[idx] = session;
  else all.push(session);
  writeAll(all);
}

export function deleteSession(id) {
  writeAll(readAll().filter((s) => s.id !== id));
}

export const THEME_GRADIENTS = {
  reflection: ["#3A322C", "#C77D63"],
  grief: ["#2A2F35", "#7A8FA6"],
  anxiety: ["#2E2A3A", "#8A7BB0"],
  work: ["#2E332B", "#83937B"],
  relationships: ["#3A2C2C", "#C77D63"],
  self: ["#33302B", "#D1C3B4"],
};

export function themeGradient(theme) {
  return THEME_GRADIENTS[theme] || THEME_GRADIENTS.reflection;
}
